var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"construction-group"},[_c('SimpleTable',{ref:"vtableRef",attrs:{"showIndex":"","table-code":"constructionGroup","columns":_vm.columns,"data":_vm.tableData,"menus":['查询', '插入', '批量删除', '批量修改']},on:{"modify-data-change":_vm.onModifyDataChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }